import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Executive from '../../dropdown/executive';
import { Grid } from 'semantic-ui-react';

class Followup extends React.Component {

  state = {

  }

  update(type, value, data) {
    this.setState({ executive: value, data: data })
  }

  handleChange = name => event => {
    this.setState({
      due_date: event.target.value,
    });
  }

  submit() {
    if (this.state.due_date == undefined || this.state.due_date == '' || this.state.due_date == null) {
      alert('Enter the Due Date!!!');
      return;
    }
    if (this.state.executive == undefined || this.state.executive == '' || this.state.executive == null) {
      alert('Select the Executive!!!');
      return;
    }
    this.props.updatefollowupDetails(this.state.due_date, this.state.executive);
  }

  render() {
    return (
      <div>
      <Dialog fullScreen={this.state.fullScreen} open={this.props.open}
        onClose={this.props.close} aria-labelledby="responsive-dialog-title" >
        <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
          {"Follow Up"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Executive<br/>
                <Executive update={this.update.bind(this)} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Due Date<br/>
                <input type='date' value={this.state.due_date} onChange={this.handleChange('date')} />
              </Grid.Column>
            </Grid>
            <br/><br/><br/><br/>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button primary onClick={this.submit.bind(this)}>Submit</Button>
          <Button primary onClick={this.props.close}>Close</Button>
        </DialogActions>
      </Dialog>
      </div>
    );
  }
}

export default Followup;
